import { IosDependenciesReleaseReport, IosDependenciesReleaseResponse } from '@/types/iosDependencies';

export const TRY_FETCH_IOS_DEPENDENCIES_FOR_RELEASE = 'TRY_FETCH_IOS_DEPENDENCIES_FOR_RELEASE';
export const FETCH_IOS_DEPENDENCIES_FOR_RELEASE_SUCCESS = 'FETCH_IOS_DEPENDENCIES_FOR_RELEASE_SUCCESS';
export const UPDATE_IOS_DEPENDENCIES_FOR_RELEASE = 'UPDATE_IOS_DEPENDENCIES_FOR_RELEASE';
export const UPDATE_IOS_DEPENDENCIES_REPORT_FOR_RELEASE = 'UPDATE_IOS_DEPENDENCIES_REPORT_FOR_RELEASE';

export interface FetchIosDependenciesRequest {
    orgId: string;
    appId: string;
    releaseId: string;
}

export interface TryFetchIosDependenciesForReleaseAction {
    type: typeof TRY_FETCH_IOS_DEPENDENCIES_FOR_RELEASE;
    payload: FetchIosDependenciesRequest;
}

export interface FetchIosDependenciesForReleaseSuccessPayload {
    releaseId: string;
    response: IosDependenciesReleaseResponse;
}

export interface FetchIosDependenciesForReleaseSuccessAction {
    type: typeof FETCH_IOS_DEPENDENCIES_FOR_RELEASE_SUCCESS;
    payload: FetchIosDependenciesForReleaseSuccessPayload;
}

export interface UpdateIosDependenciesForReleaseAction {
    type: typeof UPDATE_IOS_DEPENDENCIES_FOR_RELEASE;
    payload: FetchIosDependenciesForReleaseSuccessPayload;
}

export interface UpdateIosDependenciesReportForReleasePayload {
    releaseId: string;
    report: IosDependenciesReleaseReport;
}

export interface UpdateIosDependenciesReportForReleaseAction {
    type: typeof UPDATE_IOS_DEPENDENCIES_REPORT_FOR_RELEASE;
    payload: UpdateIosDependenciesReportForReleasePayload;
}

export const tryFetchIosDependenciesForRelease = (
    payload: FetchIosDependenciesRequest,
): TryFetchIosDependenciesForReleaseAction => ({
    type: TRY_FETCH_IOS_DEPENDENCIES_FOR_RELEASE,
    payload,
});

export const fetchIosDependenciesForReleaseSuccess = (
    payload: FetchIosDependenciesForReleaseSuccessPayload,
): FetchIosDependenciesForReleaseSuccessAction => ({
    type: FETCH_IOS_DEPENDENCIES_FOR_RELEASE_SUCCESS,
    payload,
});

export const updateIosDependenciesForRelease = (
    payload: FetchIosDependenciesForReleaseSuccessPayload,
): UpdateIosDependenciesForReleaseAction => ({
    type: UPDATE_IOS_DEPENDENCIES_FOR_RELEASE,
    payload,
});

export const updateIosDependenciesReportForRelease = (
    payload: UpdateIosDependenciesReportForReleasePayload,
): UpdateIosDependenciesReportForReleaseAction => ({
    type: UPDATE_IOS_DEPENDENCIES_REPORT_FOR_RELEASE,
    payload,
});

export type IosDependenciesAction =
    | TryFetchIosDependenciesForReleaseAction
    | FetchIosDependenciesForReleaseSuccessAction
    | UpdateIosDependenciesForReleaseAction
    | UpdateIosDependenciesReportForReleaseAction;
